import React from 'react'
import MicrosoftLogo from 'images/MicrosoftLogo'
import styled from '@emotion/styled'
import withProps from 'recompose/withProps'
import urlForProvider from '../utils/urlForProvider'
import { Button, color } from 'stylist'

const MicrosoftButton = styled(Button)`
  border: 0 none;
  padding: 0;
  background: ${color('white')};
`

export default withProps(({ label, onError, valid }) => ({
  children: <MicrosoftLogo alt="Microsoft" />,

  onClick: e => {
    e.preventDefault()
    if (valid) {
      window.location.replace(urlForProvider('azure'))
    } else {
      onError()
    }
  }
}))(MicrosoftButton)



// WEBPACK FOOTER //
// ./src/components/MicrosoftButton.js